export class ContactMessage {
    constructor(
    public id: number,
    public firstName: string,
    public name: string,
    public email: string,
    public content: string,
    public isReaded: boolean,
    ) {}
}
